module.exports = __webpack_public_path__ + "static/img/14000279.5abd5a39.png";